"use strict";
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
Object.defineProperty(exports, "__esModule", { value: true });
const html_tags_1 = require("./html_tags");
const parser_1 = require("./parser");
var parser_2 = require("./parser");
exports.ParseTreeResult = parser_2.ParseTreeResult;
exports.TreeError = parser_2.TreeError;
class HtmlParser extends parser_1.Parser {
    constructor() { super(html_tags_1.getHtmlTagDefinition); }
    parse(source, url, options, isTagNameCaseSensitive = false) {
        return super.parse(source, url, options, isTagNameCaseSensitive);
    }
}
exports.HtmlParser = HtmlParser;
